/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import {Component} from 'preact';
import PropTypes from 'prop-types';
import VideoPreview from '../components/VideoPreview';

class VideoContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mediaStream !== this.props.mediaStream) {
      if (prevProps.mediaStream) {
        const videoTracks = prevProps.mediaStream.getVideoTracks();

        if (videoTracks && videoTracks.length > 0) {
          videoTracks.forEach((videoTrack) => {
            videoTrack.stop();
            prevProps.mediaStream.removeTrack(videoTrack);
          });
        }
      }

      if (this.props.mediaStream) {
        let videoSelectPreviewElem = document.getElementById('videoSelectPreview');

        if (videoSelectPreviewElem) {
          videoSelectPreviewElem.srcObject = this.props.mediaStream;
        }
      }
    }
  }

  render() {
    const propsStyle = this.props.propsStyle || {};

    return (
      <VideoPreview
        propsStyle={propsStyle}
      />
    );
  }
}

VideoContainer.propTypes = {
  propsStyle: PropTypes.object,
  mediaStream: PropTypes.object
};

export default VideoContainer;